import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/auth.action';
import { useDispatch } from 'react-redux';

export default function SearchEmployee({ updateEmployee=null, defaultValue=null, required=false, id="employee_id", reset=false }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [q, setQ] = useState("");
    const [employee, setEmployee] = useState(defaultValue);
    const [employees, setEmployees] = useState([]);
    const [isTouched, setIsTouched] = useState(false);

    const searchEmployees = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }employees/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setEmployees(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchEmployees();
    }, [searchEmployees, location]);

    useEffect(() => {
        if(reset)
            setIsTouched(false);
    }, [reset]);

    useEffect(() => {
        if(q.length >= 2){
            searchEmployees(q);
        }
    }, [searchEmployees, q]);
    
    useEffect(() => {
        setQ("");
        if(updateEmployee && employee){
            updateEmployee(employee);
        }
    }, [updateEmployee, employee]);

    useEffect(() => {
        setEmployee(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <>
            <div className='autocomplete'>
                <label htmlFor={ id } className='form-control'>{ employee ? (employee.last_name + " " + employee.first_name) : 'Rechercher un employé' }</label>
                <input type='text' ref={ autocompleteInputRef } id={ id } onFocus={ () => {
                    setIsAutocompleteOpen(true);
                }} placeholder={ employee ? (employee.last_name + " " + employee.first_name) : 'Rechercher un employé' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } onBlur={ () => setIsTouched(true) } />
                <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                    { employees.map(item => {
                        return(
                            <li key={ item.id } onClick={ () => {
                                setEmployee(item);
                                setIsAutocompleteOpen(false);
                            } }><i className='fa fa-search'></i> { item.last_name + " " + item.first_name } { item.status ? <span className='badge bg-success'><i className='fa fa-check-circle'></i> Actif</span> : <span className='badge bg-danger'><i className='fa fa-times-circle'></i> Inactif</span> }</li>
                        )
                    }) }
                    { employees.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
                </ul>
            </div>
            { isTouched && required && employee === null && <div className='form-error'>Veuillez sélectionner l'employé.</div> }
        </>
    )
}
